import React from 'react';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { getAppPermissionsState } from '../../../common/store/comments/comments-permissions';
import { UserAction } from '../../../controller/services/comments-service-types';
import { useApi } from '../../context/api-context/use-api';
import CommentList from '../comment-list/comment-list';
import { useListFitsToScreen } from '../comment-list/use-list-fits-to-screen';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import StartRootBoxSection from '../root-box-sections/start-root-box-section';
import EndRootBoxSection from '../root-box-sections/end-root-box-section';
import RootBoxEffectProvider from '../../context/root-box-effect-context/root-box-effect-provider';
const AppReady = ({ listState, appHeaderIsVisible }) => {
    const { resourceId, isLocked, isPreconditionRequiredForAction, repliesCreation, disableWriteBeforeLogin, commentBoxPosition, } = useConfiguration();
    const { fetchNextComments, fetchPrevComments, fetchNextReplies, fetchPrevReplies, currentOwner, isMobile, forceShowCommentBoxes, } = useApi((state, actions, _, ctx) => ({
        fetchNextComments: actions.fetchNextComments,
        fetchPrevComments: actions.fetchPrevComments,
        fetchNextReplies: actions.fetchNextReplies,
        fetchPrevReplies: actions.fetchPrevReplies,
        changeOrdering: actions.changeOrdering,
        currentOwner: state.members.currentOwner,
        isMobile: getIsMobile(state),
        forceShowCommentBoxes: ctx.wcDevToolsState.forceShowCommentBoxes,
    }));
    const { listRef, listFitsToScreen } = useListFitsToScreen(resourceId, listState.commentList.length);
    const permissions = listState.type === 'READY' ? listState.permissions : null;
    const appPermissionState = React.useMemo(() => getAppPermissionsState({
        isLocked,
        permissions: permissions,
        currentOwner,
        isPreconditionRequiredForAction,
        isRepliesDisabled: repliesCreation === 'DISABLED',
        isWriteBeforeLoginDisabled: disableWriteBeforeLogin,
    }), [
        isLocked,
        permissions,
        currentOwner,
        isPreconditionRequiredForAction,
        repliesCreation,
        disableWriteBeforeLogin,
    ]);
    const commentBoxLayout = (() => {
        if (forceShowCommentBoxes) {
            return 'BOTH';
        }
        if (commentBoxPosition) {
            return commentBoxPosition === 'TOP_ONLY' ? 'TOP' : 'BOTTOM';
        }
        return listFitsToScreen ? 'TOP' : 'BOTH';
    })();
    const boxRating = React.useMemo(() => (Object.assign(Object.assign({}, listState.ratings.inputRating), { previousExists: !!listState.ratings.currentRating.value })), [listState.ratings.inputRating, listState.ratings.currentRating.value]);
    return (React.createElement(RootBoxEffectProvider, { effectState: listState.commentBox },
        React.createElement(StartRootBoxSection, { addCommentPermission: appPermissionState[UserAction.ADD_COMMENT], isListEmpty: listState.isEmpty, someoneIsTyping: listState.someoneIsTyping, appHeaderIsVisible: appHeaderIsVisible, shouldShowCommentBox: commentBoxLayout !== 'BOTTOM', boxRating: boxRating, canRate: appPermissionState[UserAction.RATE].type === 'ALLOW' }),
        React.createElement(CommentList, { ref: listRef, fetchNextComments: () => fetchNextComments({ resourceId }), fetchPrevComments: () => fetchPrevComments({ resourceId }), fetchNextReplies: (commentId) => fetchNextReplies({ resourceId, commentId }), fetchPrevReplies: (commentId) => fetchPrevReplies({ resourceId, commentId }), state: listState, appPermissionState: appPermissionState, isMobile: isMobile, liveCommentsLayout: commentBoxLayout }),
        commentBoxLayout !== 'TOP' ? (React.createElement(EndRootBoxSection, { addCommentPermission: appPermissionState[UserAction.ADD_COMMENT], someoneIsTyping: listState.someoneIsTyping, boxRating: boxRating, canRate: appPermissionState[UserAction.RATE].type === 'ALLOW' })) : null));
};
AppReady.displayName = 'AppReady';
export default AppReady;
//# sourceMappingURL=app-ready.js.map